import { ofType } from 'redux-observable';
import {
  catchError,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { DELETE_INCARICO } from '../../data.const';
import {
  retrieveIncaricoListAction,
  setLoaders,
  setPopupInfo,
} from '../../data.action';

const deleteIncaricoEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(DELETE_INCARICO),
    map(({ payload: { ids, isCestino, ...rest } }: any) => ({
      body: {
        ids,
        isCestino,
      },
      listBody: { ...rest, isCestino },
    })),
    // tap(p => console.log(`[epic ${DELETE_INCARICO}]`, p)),
    withLatestFrom(state$),
    switchMap(([{ body, listBody }, _state]) => {
      return concat(
        of(setLoaders({ incaricoLoader: true })),
        defer(() =>
          from(
            request({ path: `incarico`, method: httpMethods.DELETE, body })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return p;
            }),
            // tap(p => console.log(`[epic ${DELETE_INCARICO}]`, p)),
            // switchMap(() => EMPTY),
            switchMap(() => of(retrieveIncaricoListAction(listBody))),
            catchError(err => {
              console.error(`[epic ${DELETE_INCARICO}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ incaricoLoader: false }))
      );
    })
  );

export default deleteIncaricoEpic;
